import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextInput from 'app/components/TextInput';
import TextEvents from 'app/components/TextEvents';
import FrontContainer from 'app/containers/FrontContainer';
import CommunicationProgramKeyUserDetailsContainer from 'app/containers/CommunicationProgramKeyUserDetailsContainer';
import { fetchCommunicationProgramDetails, clearCommunicationProgramDetails, EXPORT_CA_REQUEST, EXPORT_CA_SUCCESS, EXPORT_CA_FAILURE } from 'app/actions/CommunicationProgramKeyUserActions';

import ApiService from 'app/services/ApiService';
import { Select, Button, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';


const { Option } = Select;

export default function ComplianceAdvanceDetailForm(props) {

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const dispatch = useDispatch();

    let [frontList, setFrontList] = useState();
    const [front, setFront] = useState('');
    const [sorter, setSorter] = useState({});
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'] });

    const data = {
        frontId: front,
        limit: pagination.pageSize,
        offset: (0 * pagination.pageSize),
        sortColumn: Object.keys(sorter).length > 0 ? sorter.field : '',
        sortDir: Object.keys(sorter).length > 0 ? sorter.order === 'ascend' ? 'ASC' : 'DESC' : '',
        subdirectionId: props.subdirectionId /*Unused*/
        , EsSuperAdmin: 0,
    }

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const {
        isLoadingCAExport
    } = useSelector(state => state.CommunicationProgram);

    const isOilService = props.subdirectionId === 3;

    const search = () => {
        var respnse = IsSuperAdmin();
        data.EsSuperAdmin = respnse ? 1 : 0;
        dispatch(clearCommunicationProgramDetails());
        dispatch(fetchCommunicationProgramDetails(data, props.rowData.idCommunicationProgram));
    }
    const toExport = async () => {
        dispatch({ type: EXPORT_CA_REQUEST });
        var respnse = IsSuperAdmin();
        data.EsSuperAdmin = respnse ? 1 : 0;

        await ApiService.exportCommunicationProgramsById(data, props.rowData.idCommunicationProgram)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, 'ProgramadeComunicaciones.xlsx');
                    dispatch({ type: EXPORT_CA_SUCCESS });
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    dispatch({ type: EXPORT_CA_FAILURE });
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }
    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const SelectFrontItem = (name = [], value) => {
        setFrontList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            setFront([])
        }
        i.forEach(() => {
            if (key === 'frontName') {
                let newFrontList = [];
                array.map(i => {
                    return frontList.map(ids => {
                        const res = ids['idFront'];
                        return ids.frontName === i ? newFrontList.push(res) : null
                    })
                })
                setFront(String(newFrontList))
            }
        })
        if (array.length === 0) {
            // dispatch(clearCommunicationProgramSummary())
            // dispatch(fetchCommunicationProgramSummary(data));
        }
    }

    const onClickRow = (record, row, e) => {
        if (record.idCategory) {
            props.setCategoryData(record)
            props.setVisibleChildren(true)
        }
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });


    return (
        <div>
            <Grid container direction='row'>
                {/*<Grid item xs={4} style={props.styles.inputSelect}>
                    <TextInput
                        value={props.rowData.subdirectionName}
                        disabled
                        text='Subdirección'
                        mode='input'
                        color='darker'
                        size='label'
                        weight='medium'
                    >
                    </TextInput>
                </Grid>*/}
                <Grid item xs={isOilService ? 4 : 8} style={props.styles.inputSelect}>
                    <TextInput
                        value={props.rowData.communicationProgramName}
                        disabled
                        text='PDC'
                        mode='input'
                        color='darker'
                        size='label'
                        weight='medium'
                        style={props.styles.inputSelect}
                    >
                    </TextInput>
                </Grid>
                {isOilService ? (<Grid item xs={4} style={props.styles.inputSelect}>
                    <TextInput
                        value={props.rowData.contractName}
                        disabled
                        text='Contrato'
                        mode='input'
                        color='darker'
                        size='label'
                        weight='medium'
                    >
                    </TextInput>
                </Grid>) : null}

                {isOilService ? (<Grid item xs={4} style={props.styles.inputSelect}>
                    <TextInput
                        value={props.rowData.workName}
                        disabled
                        text='OT'
                        mode='input'
                        color='darker'
                        size='label'
                        weight='medium'
                        style={props.styles.inputSelect}
                    >
                    </TextInput>
                </Grid>) : null}
            </Grid>
            {isOilService ? (<Grid container direction='row'>
                <Grid item xs={6}>
                    <TextEvents
                        text='Frente'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <FrontContainer>
                        {(front) => {
                            return (
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    mode='multiple'
                                    style={props.styles.inputSelect}
                                    placeholder='Seleccion Frente'
                                    onChange={(v, i) => handleChange(v, i, 'frontName')}
                                >
                                    {SelectFrontItem(front.front, 'frontName')}
                                </Select>
                            )
                        }}
                    </FrontContainer>
                </Grid>
            </Grid>) : null}
            <div className={props.classes.container} style={props.styles.baseVerticalMargin}>
                {isOilService ? (<Button
                    className={props.classes.button}
                    variant='contained'
                    type='primary'
                    onClick={() => search()}
                >
                    Buscar
                </Button>) : null}
                <Button
                    className={props.classes.button}
                    variant='contained'
                    type='primary'
                    onClick={toExport}
                    loading={isLoadingCAExport}
                >
                    Exportar
                </Button>
            </div>
            <div>
                <CommunicationProgramKeyUserDetailsContainer pagination={pagination}
                    sorter={sorter}
                    setSorter={setSorter}
                    formData={data}
                    setPagination={setPagination}
                    idCommunicationProgram={props.rowData.idCommunicationProgram}
                >
                    {(communication) => {
                        return <Grid container direction='row'>
                            <Table
                                loading={communication.isLoading}
                                columns={communication.cols}
                                dataSource={communication.communicationProgramDetails}
                                rowKey={item => String(item.specialtyName)}
                                style={{ cursor: 'pointer' }}
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: () => { onClickRow(record, rowIndex) }, // click row
                                    };
                                }}
                                pagination={pagination}
                                // scroll={{ y: 340, x: '100%'}}
                                scroll={{ x: '100%', y: (height - 415) }}
                                size={"small"}
                                onChange={communication.handleTableChange}
                            />
                        </Grid>
                    }}
                </CommunicationProgramKeyUserDetailsContainer>
            </div>
        </div>
    )

}